import doc from '../../../../../assets/Imagess/mail/doc.svg';
import jpg from '../../../../../assets/Imagess/mail/jpg.svg';
import mp4 from '../../../../../assets/Imagess/mail/mp4.svg';
import pdf from '../../../../../assets/Imagess/mail/pdf.svg';
import png from '../../../../../assets/Imagess/mail/png.svg';
import ppt from '../../../../../assets/Imagess/mail/ppt.svg';
import txt from '../../../../../assets/Imagess/mail/txt.svg';
import zip from '../../../../../assets/Imagess/mail/zip.svg';
import xls from '../../../../../assets/Imagess/mail/xls.svg';

export function imageSrc(fileType) {
  switch (fileType?.toLowerCase()) {
    case 'pdf':
      return pdf;
    case 'doc':
    case 'docx':
      return doc;
    case 'jpg':
    case 'jpeg':
    case 'webp':
    case 'svg+xml':
    case 'svg':
      return jpg;
    case 'xls':
    case 'xlsx':
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return xls;
    case 'png':
      return png;
    case 'mp4':
      return mp4;
    case 'ppt':
    case 'pptx':
      return ppt;
    case 'txt':
      return txt;
    case 'zip':
    case 'rar':
      return zip;
    default:
      return txt;
  }
}
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject('No file provided');
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64String = reader.result.split(',')[1];

      resolve({
        fileName: file.name,
        contentType: file.type,
        fileContent: base64String,
      });
    };
    //test

    reader.onerror = (error) => reject('Error reading file ' + error);
  });
};

export default fileToBase64;
